function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.0002,
  cy: 19.5998,
  rx: 2.8,
  ry: 2.8,
  stroke: "white",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4001 12.4082V5.59961H12.6001V12.4082",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.80005 9.79971L9.10005 4.19971H6.30005L7.00005 9.79971",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.95 5.5998L12.6 2.7998H9.80005L10.5 11.1998",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2 9.79971L18.9 4.19971H21.7L21 9.79971",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.05 5.5998L15.4 2.7998H18.2L17.5 11.1998",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4001 9.7998L23.3924 9.92384C23.428 9.63922 23.3396 9.35303 23.1498 9.138C22.9599 8.92297 22.6869 8.7998 22.4001 8.7998V9.7998ZM20.3001 26.5998V27.5998C20.8044 27.5998 21.2298 27.2243 21.2924 26.7238L20.3001 26.5998ZM7.7001 26.5998L6.70782 26.7238C6.77037 27.2243 7.19577 27.5998 7.7001 27.5998V26.5998ZM5.6001 9.7998V8.7998C5.31327 8.7998 5.04024 8.92297 4.85042 9.138C4.66059 9.35303 4.57224 9.63922 4.60782 9.92384L5.6001 9.7998ZM9.8001 9.7998H10.8001C10.8001 9.24752 10.3524 8.7998 9.8001 8.7998V9.7998ZM18.2001 9.7998V8.7998C17.6478 8.7998 17.2001 9.24752 17.2001 9.7998H18.2001ZM21.4078 9.67577L19.3078 26.4758L21.2924 26.7238L23.3924 9.92384L21.4078 9.67577ZM20.3001 25.5998H7.7001V27.5998H20.3001V25.5998ZM8.69238 26.4758L6.59238 9.67577L4.60782 9.92384L6.70782 26.7238L8.69238 26.4758ZM5.6001 10.7998H9.8001V8.7998H5.6001V10.7998ZM18.2001 10.7998H22.4001V8.7998H18.2001V10.7998ZM9.8001 9.7998C8.8001 9.7998 8.8001 9.80055 8.8001 9.8013C8.8001 9.80157 8.8001 9.80234 8.8001 9.80287C8.80011 9.80394 8.80011 9.80506 8.80012 9.80622C8.80013 9.80854 8.80015 9.81105 8.80018 9.81374C8.80025 9.81911 8.80035 9.82522 8.80052 9.83202C8.80085 9.84563 8.80142 9.86208 8.80237 9.88119C8.80428 9.91936 8.80775 9.96835 8.81399 10.0267C8.82645 10.1429 8.85018 10.2982 8.89558 10.4798C8.9861 10.8419 9.1661 11.3211 9.5251 11.7998C10.2777 12.8033 11.6561 13.5998 14.0001 13.5998V11.5998C12.1441 11.5998 11.4225 10.9963 11.1251 10.5998C10.9591 10.3785 10.8766 10.1577 10.8359 9.99477C10.8156 9.91386 10.8066 9.85045 10.8026 9.81358C10.8007 9.79532 10.8 9.78416 10.7999 9.78131C10.7998 9.77991 10.7999 9.78064 10.7999 9.78365C10.8 9.78516 10.8 9.78725 10.8 9.78993C10.8001 9.79127 10.8001 9.79276 10.8001 9.79441C10.8001 9.79523 10.8001 9.79609 10.8001 9.79699C10.8001 9.79744 10.8001 9.79815 10.8001 9.79837C10.8001 9.79908 10.8001 9.7998 9.8001 9.7998ZM14.0001 13.5998C16.3441 13.5998 17.7225 12.8033 18.4751 11.7998C18.8341 11.3211 19.0141 10.8419 19.1046 10.4798C19.15 10.2982 19.1737 10.1429 19.1862 10.0267C19.1924 9.96835 19.1959 9.91936 19.1978 9.88119C19.1988 9.86208 19.1993 9.84563 19.1997 9.83202C19.1998 9.82522 19.1999 9.81911 19.2 9.81374C19.2 9.81105 19.2001 9.80854 19.2001 9.80622C19.2001 9.80506 19.2001 9.80394 19.2001 9.80287C19.2001 9.80234 19.2001 9.80157 19.2001 9.8013C19.2001 9.80055 19.2001 9.7998 18.2001 9.7998C17.2001 9.7998 17.2001 9.79908 17.2001 9.79837C17.2001 9.79815 17.2001 9.79744 17.2001 9.79699C17.2001 9.79609 17.2001 9.79523 17.2001 9.79441C17.2001 9.79276 17.2001 9.79127 17.2002 9.78993C17.2002 9.78725 17.2002 9.78516 17.2003 9.78365C17.2003 9.78064 17.2004 9.77991 17.2003 9.78131C17.2002 9.78416 17.1995 9.79532 17.1976 9.81358C17.1936 9.85045 17.1846 9.91386 17.1643 9.99477C17.1236 10.1577 17.0411 10.3785 16.8751 10.5998C16.5777 10.9963 15.8561 11.5998 14.0001 11.5998V13.5998Z",
  fill: "white"
});

var SvgFrenchFries = function SvgFrenchFries(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFrenchFries, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/french-fries.a26f7888.svg";
export { ForwardRef as ReactComponent };